export const getObjectKeyByDepthLvl = (object, depthLvl) => {
  if(object) {
    const insideObj = Object.values(object)[0]
    if (depthLvl > 1) {
      return getObjectKeyByDepthLvl(insideObj, depthLvl-1)
    }
    return Object.keys(insideObj)[0]
  }
}